import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";

/**
 * Default usecase logic for row types that have no custom logic / validation.
 */
export class DefaultUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   */
  public updateUsecase(): void {
    // Does nothings
  }

  /** Always returns null */
  public getUcValidation(): UsecaseValidationMessage | undefined {
    return undefined;
  }
}
